<template>
  <div class="entering-wrapper">
    <!-- <entering-step :step="step" stepOneText="个人信息" stepTwoText="线下首诊信息" /> -->
    <!-- 第一部分 -->
    <div class="form-wrapper">
      <!-- 真实姓名 -->
      <div class="form-item click" :class="{'error': realNameError}">
        <div class="form-type"><span class="required">真实姓名</span></div>
        <div class="form-content">
          <input type="text" class="form-text" placeholder="请输入姓名" v-model="realName" :disabled="hasName">
        </div>
        <div class="form-error" v-if="realNameError">
          <van-icon name="fail" />{{realNameErrorMsg}}</div>
      </div>
      <!-- 性别 -->
      <div class="form-item click" :class="{'error': genderError}" @click="pickGender">
        <div class="form-type"><span class="required">性别</span></div>
        <div class="form-content" :class="{'disabled': hasGender}">
          <div class="picker-tips" v-if="!gender">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{this.gender | sexFilter}}</div>
        </div>
        <div class="form-error" v-if="genderError">
          <van-icon name="fail" />{{genderErrorMsg}}</div>
      </div>

      <!-- 出生年月 -->
      <div class="form-item click" @click="showBornPicker">
        <div class="form-type"><span class="required">出生年月</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!born">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{born | parseDateToMonth}}</div>
        </div>
      </div>

      <!-- 过敏史 -->
      <div class="form-item click" :class="{'editable-item': allergy == '有'}" @click="allergyPickerShow = true">
        <div class="form-type"><span class="required">过敏史</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!allergy">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{allergy}}</div>
        </div>
      </div>
      <div class="allergy-textarea" v-if="allergy == '有'">
        <textarea class="form-textarea" placeholder="如有过敏史请说明" v-ios-bug-fixed v-model="allergyText" maxlength="100"></textarea>
        <span class="textarea-limit">{{allergyText.length}}/100</span>
      </div>

      <!-- 所在地 -->
      <div class="form-item click" @click="areaPickerShow = true">
        <div class="form-type"><span class="required">所在地</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!location.province">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{location.province}}</div>
        </div>
      </div>

    </div>
    <!-- 第二部分 -->
    <div class="form-wrapper">
      <div class="form-item" :class="{'error': phoneError}">
        <div class="form-type"><span class="required">手机号</span></div>
        <div class="form-content">
          <input type="text" class="form-text" placeholder="请输入" v-model="phone" :disabled="bindedPhone">
        </div>
        <div class="form-error" v-if="phoneError">
          <van-icon name="fail" />{{phoneErrorMsg}}</div>
      </div>
      <div class="form-item" v-if="!bindedPhone">
        <div class="code-input-box"><input type="number" class="code-input" v-model="code" @input="codeChange"
            placeholder="请输入验证码"></div>
        <div class="form-content">
          <button class="get-code-button" @click="countdown" :disabled="sandingCode">
            <span v-if="sandingCode">已发送 {{time}}s</span>
            <span v-else>获取验证码</span>
          </button>
        </div>
      </div>
    </div>
    <div class="submit-box"><button class="submit-button" @click="nextStep" :disabled="submitting">确认患者信息</button></div>

    <!-- 弹出层 -->
    <van-popup v-model="areaPickerShow" position="bottom">
      <van-area :area-list="areaList" :columns-num="1" title="所在地区" @cancel="areaPickerShow = false" @confirm="confirmLocation" />
    </van-popup>
    <!-- 性别选择 -->
    <van-popup v-model="genderPickerShow" position="bottom">
      <van-picker show-toolbar :columns="genderData" value-key="label" @cancel="genderPickerShow = false" @confirm="confirmGender" />
    </van-popup>
    <!-- 出生年月选择 -->
    <van-popup v-model="bornPickerShow" position="bottom">
      <van-datetime-picker show-toolbar type="year-month" v-model="born" :formatter="formatter" :max-date="maxDate"
        :min-date="minDate" @cancel="bornPickerShow = false" @confirm="confirmBirthday" />
    </van-popup>
    <!-- 过敏史选择 -->
    <van-popup v-model="allergyPickerShow" position="bottom">
      <van-picker show-toolbar :columns="allergyOptions" @cancel="allergyPickerShow = false" @confirm="confirmAllergy" />
    </van-popup>

    <!-- 选择开方剂型弹窗 -->
    <van-popup v-model="chooseFormulation" position="bottom">
      <div class="popup-wrapper">
        <div class="popup-header">
          选择药品类别
          <span class="close-popup" @click="chooseFormulation = false">取消</span>
        </div>
        <div class="formulation-wrapper" v-if="userInfo.doctor_type == 1">
          <div class="formulation-list">
            <router-link class="formulation-item" :to="{path: '/doctor/diagnose', query: {pat_id: pat_id, type: 2}}">
              <div class="icon-box">
                <icon icon-class="grain-medicine"></icon>
              </div>
              配方颗粒
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnose', query: {pat_id: pat_id, type: 1}}">
              <div class="icon-box">
                <icon icon-class="traditional-medicine"></icon>
              </div>
              中药饮片
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnoseWest', query: {pat_id: pat_id, type: 5}}">
              <div class="icon-box">
                <icon icon-class="westen-medicine"></icon>
              </div>
              西药
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnoseWest', query: {pat_id: pat_id, type: 6}}">
              <div class="icon-box">
                <icon icon-class="chinese-medicine"></icon>
              </div>
              中成药
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnoseWest', query: {pat_id: pat_id, type: 3}}">
              <div class="icon-box">
                <icon icon-class="instrument"></icon>
              </div>
              器械耗材
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnose-photo', query: {pat_id: pat_id, type: 8}}">
              <div class="icon-box"> <img style="width:50px" src="@/assets/images/icons/icon-photo-pres.png" /></div>
              拍方上传
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnosePrivate', query: {pat_id: pat_id, type: 7}}">
              <div class="icon-box"> <img style="width:50px" src="@/assets/images/icons/private-icon-main.png" /></div>
              协定方
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnoseGroup', query: {pat_id: targetId, type: 9}}" >
              <div class="icon-box"> <img style="width:50px" src="@/assets/images/icons/group.png" /></div>
              转诊单
            </router-link>

          </div>
        </div>
        <div class="formulation-wrapper" v-else>
          <div class="formulation-list">
            <router-link class="formulation-item" :to="{path: '/doctor/diagnoseWest', query: {pat_id: pat_id, type: 5}}">
              <div class="icon-box">
                <icon icon-class="westen-medicine"></icon>
              </div>
              西药
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnoseWest', query: {pat_id: pat_id, type: 6}}">
              <div class="icon-box">
                <icon icon-class="chinese-medicine"></icon>
              </div>
              中成药
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnoseWest', query: {pat_id: pat_id, type: 3}}">
              <div class="icon-box">
                <icon icon-class="instrument"></icon>
              </div>
              器械耗材
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnosePrivate', query: {pat_id: pat_id, type: 7}}">
              <div class="icon-box"> <img style="width:50px" src="@/assets/images/icons/private-icon-main.png" /></div>
              协定方
            </router-link>
            <router-link class="formulation-item" :to="{path: '/doctor/diagnoseGroup', query: {pat_id: targetId, type: 9}}">
              <div class="icon-box"> <img style="width:50px" src="@/assets/images/icons/private-icon-main.png" /></div>
              转诊单
            </router-link>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .formulation-wrapper{
    padding: 48px 5px 0;
    height: 100%;
    .formulation-list{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      padding-bottom: 56px;
      .formulation-item{
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 15px;
        line-height: 21px;
        color: @black;
        margin-top: 56px;
        .icon-box{
          width: 64px;
          height: 64px;
          background: rgba(54, 104, 166, 0.1);
          border-radius: 50%;
          overflow: hidden;
          box-shadow: 0px 2px 8px 0px rgba(54,104,166,0.1);
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 10px;
          svg{
            font-size: 48px;
          }
        }
        // &:nth-child(2n){
        //   position: relative;
        //   &::after{
        //     content: '';
        //     position: absolute;
        //     top: 50%;
        //     left: 0;
        //     transform: translateY(-50%);
        //     width: 1px;
        //     height: 90px;
        //     background: #EEE;
        //   }
        // }
      }
    }
  }
  .entering-wrapper{
    background: #F7F7F7;
    padding-top: 1px;
    min-height: 100vh;
  }
  .form-wrapper{
    padding: 24px 0 12px;
    margin-top: 12px;
    background: #FFF;
    .form-item{
      position: relative;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FFF;
      height: 40px;
      margin-bottom: 16px;
      transition: all .1s;
      &.vertical{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        height: auto;
        .form-content{
          position: relative;
          width: 100%;
          margin-top: 16px;
          .form-textarea{
            border: 1px solid #F7F7F7;
            background: #F7F7F7;
            resize: none;
            padding: 12px;
            font-size: 14px;
            line-height: 20px;
            color: #666;
            width: 100%;
            height: 144px;
            &::-webkit-input-placeholder{
              color: #999;
            }
          }
          .textarea-limit{
            position: absolute;
            right: 8px;
            bottom: 8px;
            font-size: 12px;
            color: #999;
          }
        }
      }
      &.avatar{
        height: 80px;
        margin-bottom: 12px;
      }
      &.click{
        cursor: pointer;
        &:active{
          background: #F9F9F9;
        }
      }
      &.error{
        margin-bottom: 28px;
        .form-content .form-text{
          color: @error;
        }
      }
      &.editable-item{
        margin-bottom: 0;
      }
      .form-type{
        font-size: 16px;
        color: #666;
        font-weight: bold;
        .required{
          position: relative;
          &::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            margin-left: 2px;
            font-size: 16px;
            color: @error;
          }
        }
        .tips{
          margin-top: 6px;
          font-size: 12px;
          color: @xile;
        }
      }
      .form-content{
        color: #666;
        font-size: 16px;
        &.disabled .picker-value{
          color: #999;
        }
        .avatar-box{
          width: 64px;
          height: 64px;
          img{
            width: 100%;
          }
        }
        .form-text{
          width: 200px;
          border: 0;
          text-align: right;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          background: transparent;
          &::-webkit-input-placeholder{
            color: #999;
          }
          &:disabled{
            -webkit-text-fill-color: #999;
            -webkit-opacity: 1;
            color: #999;
          }
        }
        .picker-tips{
          font-size: 16px;
          color: #999;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          svg{
            color: #CCC;
            position: relative;
            top: 2px;
            font-size: 14px;
            margin-left: 4px;
          }
        }
        .picker-value{
          max-width: 240px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .get-code-button{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 84px;
          height: 32px;
          border: 1px solid @xile;
          color: @xile;
          font-weight: bold;
          background: transparent;
          font-size: 12px;
          border-radius: 4px;
          transition: all .1s;
          &:disabled{
            border-color: #CCC;
            color: #CCC;
            &:active{
              opacity: 1;
            }
          }
          &:active{
            opacity: .8;
          }
        }
      }
      .code-input-box{
        .code-input{
          width: 200px;
          border: 0;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          background: transparent;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
      }
      .form-error{
        position: absolute;
        right: 16px;
        top: 100%;
        font-size: 12px;
        color: @error;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .van-icon{
          position: relative;
          top: 1px;
          width: 12px;
          height: 12px;
          background: @error;
          color: #FFF;
          border-radius: 50%;
          margin-right: 4px;
        }
      }
    }
  }
  .allergy-textarea{
    position: relative;
    padding: 0 16px;
    width: 100%;
    .form-textarea{
      border: 1px solid #F7F7F7;
      background: #F7F7F7;
      resize: none;
      padding: 12px;
      font-size: 14px;
      line-height: 20px;
      color: #666;
      width: 100%;
      height: 96px;
      &::-webkit-input-placeholder{
        color: #999;
      }
    }
    .textarea-limit{
      position: absolute;
      right: 24px;
      bottom: 8px;
      font-size: 12px;
      color: #999;
    }
  }
  .submit-box{
    padding: 24px 16px 12px;
    .submit-button{
      @button-base();
      width: 100%;
      height: 40px;
      font-size: 14px;
    }
  }
</style>

<script type="text/javascript">
  import areaList from '@/untils/area'
  import enteringStep from '@/components/Common/enteringStep'
  export default {
    data() {
      return {

        // 选择开方剂型
        chooseFormulation: false,
        pat_id: parseInt(this.$route.query.pat_id),
        pat_openid: this.$route.query.pat_openid,
        pat_isbind: parseInt(this.$route.query.is_bind),
        is_register: parseInt(this.$route.query.is_register),
        submitting: false,
        registerBtn: false,
        step: 1,
        // 真实姓名
        realName: '',
        realNameError: false,
        realNameErrorMsg: '请输入真实姓名',
        // 是否已有姓名
        hasName: false,
        // 性别
        gender: '',
        genderError: false,
        genderErrorMsg: '请选择性别',
        genderData: [{
            label: '男',
            value: 1
          },
          {
            label: '女',
            value: 2
          },
        ],
        // 所在地
        areaList,
        location: {
          province: '',
          city: ''
        },
        areaPickerShow: false,
        genderPickerShow: false,
        // 已有性别
        hasGender: false,
        // 身份证号
        IDNumber: '',
        IDNumberError: false,
        IDNumberErrorMsg: '请输入身份证号',
        // 已有身份证号
        hasIDNumber: false,
        // 出生年月
        born: null,
        bornPickerShow: false,
        // 年月最大值
        maxDate: new Date(),
        minDate: new Date(1900, 1, 1),

        // 有无过敏史
        allergy: '',
        allergyText: '',
        allergyPickerShow: false,
        allergyOptions: ['有', '否认', '不确定'],
        //手机号
        phone: '',
        phoneError: false,
        phoneErrorMsg: '请输入手机号',
        // 绑定过手机号只显示不能修改
        bindedPhone: false,
        // 验证码
        code: '',
        codeError: false,
        codeErrorMsg: '请输入验证码',
        // 倒计时
        countDownTimer: null,
        time: 60,
        sandingCode: false,
      }
    },
    computed: {

      userInfo() {
        return this.$store.state.userInfo;
      },

      // BMI计算

    },
    created() {
      console.log(this.userInfo);

      // if (this.is_register) {
      //  console.log("患者信息不为0，获取信息")
      this.bindPatData();
      //已经注册过，弹窗选择药品类型
      //} else {
      //注册
      //this.registerBtn=true;

      // }
      // this.echoData();
    },
    beforeDestroy() {
      clearInterval(this.countDownTimer);
    },
    watch: {
      realName(val) {
        if ($.trim(val) == '') {
          this.realNameError = true
          this.realNameErrorMsg = '请输入真实姓名'
        } else if (!/^([\u4e00-\u9fa5·]{2,10})$/.test($.trim(val))) {
          this.realNameError = true
          this.realNameErrorMsg = '请输入正确的姓名'
        } else {
          this.realNameError = false
        }
      },


      phone(val) {
        if ($.trim(val) == '') {
          this.phoneError = true
          this.phoneErrorMsg = '请输入手机号'
        } else if (!/^1\d{10}$/.test($.trim(val))) {
          this.phoneError = true
          this.phoneErrorMsg = '请输入正确的手机号'
        } else {
          this.phoneError = false
        }
      }
    },
    components: {
      enteringStep
    },
    methods: {
      openDialog() {
        this.chooseFormulation = true;
      },
      bindPatData() {
        this.$root.post('/getPatientBaseInfo', {
          user_id: this.pat_id,
          doc_id: this.userInfo.user_id

        }).then(data => {
          console.log(data);
          this.is_register = data.is_register;
          if (data.username != '') {
            this.realName = data.username;
            this.hasName = true;
          }
          if (data.gender) {
            this.gender = data.gender;
            this.hasGender = true;
          }
          if (data.province) {
            this.location.province = data.province;

          }
          if (data.birthday) this.born = moment(data.birthday, 'YYYY/M').toDate();
          if (data.allergy) {
            if (data.allergy == '否认' || data.allergy == '不确定') {
              this.allergy = data.allergy;
            } else {
              this.allergy = '有';
              this.allergyText = data.allergy;
            }
          }

          if (data.mobile) {
            this.phone = data.mobile;
            this.bindedPhone = true;
          }

        })
      },
      // 信息回显 =====> 已弃用
      /*
        echoData() {
          this.$root.post('/getPatientInfo', {
            user_id: this.userInfo.user_id || 0,
            doc_id: this.$route.query.doc_id,
            type: 1,
          }).then(data => {
            console.log(data);
            if (data.username != '') {
              this.realName = data.username;
              this.hasName = true;
            }
            if (data.gender) {
              this.gender = data.gender;
              this.hasGender = true;
            }
            if (data.birthday) this.born = moment(data.birthday, 'YYYY/M').toDate();
            if (data.allergy) {
              if (data.allergy == '否认' || data.allergy == '不确定') {
                this.allergy = data.allergy;
              } else {
                this.allergy = '有';
                this.allergyText = data.allergy;
              }
            }

            if (data.mobile) {
              this.phone = data.mobile;
              this.bindedPhone = true;
            }
          })
        },
        */
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`;
        } else if (type === 'month') {
          return `${value}月`
        }
        return value;
      },
      // 确认选择性别
      pickGender() {
        if (this.hasGender) return;
        this.genderPickerShow = true;
      },
      confirmGender(value) {
        this.gender = value.value;
        this.genderPickerShow = false;
      },
      // 确认选择所在地
      confirmLocation(value) {
        if (value) {
          this.location.province = value[0].name;
          //this.location.city = value[1].name;
        }
        this.areaPickerShow = false;
      },
      showBornPicker() {
        if (!this.born) {
          this.born = new Date();
        }
        this.bornPickerShow = true
      },
      // 确认出生年月
      confirmBirthday(value) {
        this.born = value;
        this.bornPickerShow = false;
      },
      // 确认过敏史
      confirmAllergy(value) {
        this.allergy = value;
        this.allergyPickerShow = false;
      },
      // 获取验证码 倒计时
      countdown() {
        if (this.phone == '' || this.phoneError) {
          this.$notify('请输入正确的手机号');
          return;
        };
        this.$root.post('/sendPhoneCode', {
          mobile: this.phone
        }).then(data => {
          console.log(data);
          if (data.status == 1) {
            countDownAction();
          } else {
            this.$notify(data.msg);
          }
        })
        let countDownAction = () => {
          this.time = 60;
          this.countDownTimer = null;
          this.sandingCode = true;
          let timeDown = () => {
            this.time -= 1;
            if (this.time <= 0) {
              clearInterval(this.countDownTimer);
              this.sandingCode = false;
            }
          }
          this.countDownTimer = setInterval(timeDown, 1000);
        }
      },
      codeChange(e) {
        if (this.code.length > 6) {
          this.code = this.code.slice(0, 6);
        }
      },
      register(callBack) {
        // 表单验证
        if (!this.realName || this.realNameError) {
          this.$notify(this.realNameErrorMsg);
          return;
        }
        if (!this.gender) {
          this.$notify('请选择性别');
          return;
        }
        if (!this.location.province) {
          this.$notify('请选择所在地');
          return;
        }
        if (!this.born) {
          this.$notify('请选择出生年月');
          return;
        }
        if (!this.allergy) {
          this.$notify('请选择过敏史');
          return;
        }
        if (this.allergy == '有' && !this.allergyText) {
          this.$notify('请填写过敏史说明');
          return;
        }
        if (!this.phone || this.phoneError) {
          this.$notify(this.phoneErrorMsg);
          return;
        }
        if (!this.bindedPhone && !this.code) {
          this.$notify('请输入正确的验证码');
          return;
        }
        this.submitting = true;
        let postData = {
          user_id: this.pat_id,
          user_openid: this.pat_openid,
          user_token: "",
          doc_id: this.userInfo.user_id,
          role: 2,
          username: this.realName,
          gender: this.gender,

          birthday: moment(this.born).format('YYYY/M'),

          allergy: (this.allergy == '否认' || this.allergy == '不确定') ? this.allergy : this.allergyText,
          province: this.location.province,
          mobile: this.phone,
          code: this.code,
        }
        // 如果手机号为已绑定，则不发送验证码字段 =====> 已弃用
        if (this.bindedPhone) {
          delete postData.code;
        }
        this.$root.post('/register', postData).then(data => {
          console.log(data);
          this.submitting = false;
          if (data.status == 1) {
            callBack && callBack();
            /*
            // 更新本地用户信息
            this.userInfo.user_id = data.user_id;
            this.userInfo.avatar = data.avatar;
            this.userInfo.token = data.token;
            this.userInfo.role = this.role;
            this.userInfo.gender = this.gender;
           // store.set('userInfo', this.userInfo);
           // this.$store.commit('setUserInfo', this.userInfo);
            if (this.userInfo.token) {
              // 初始化IM
              let _this = this;
              this.$root.IMInit(this.userInfo.token, {
                connectSuccess() {
                  _this.$router.replace('/patient');
                }
              });
            } else {
              this.$notify('未获取到token');
            }
            */
            // this.$router.push({path: '/patient/medical-record', query: {private_id: data.private_id, doc_id: this.$route.query.doc_id}})
          } else {
            this.$notify(data.msg);
          }
        })
      },

      nextStep() {
        let _this = this;
        if (_this.is_register) {
          _this.openDialog();
          //console.log("用户注册并填写了手机号")
        } else {
          _this.register(() => {
            _this.is_register = 1;
            _this.openDialog();

          });
          console.log("进入注册逻辑")
          //this.register();
        }

      }
    },
    filters: {
      sexFilter(value) {
        if (value == 1) {
          return '男'
        } else if (value == 2) {
          return '女'
        } else {
          return ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/ToFace/patinfo.vue